module.exports = __webpack_public_path__ + "img/DarkTechMicSvg_4_5animated.365d04e9.svg";